import { DataType, KeyedSource } from '../types/resolvers';
import { NonNullUndefinedField } from '../types/sdk';

/**
 *  checks if items is object type or not
 * @param item
 * @returns
 */
function isObject(item: unknown): item is Record<string, unknown> {
  return !!item && typeof item === 'object' && !Array.isArray(item);
}

/**
 *
 * @param param - KeyedSource<DataType.ANY>[]
 * @description parse KeyedSource for non-dynamic sources
 * @returns {Record<string, string | boolean | undefined>} - parsed key-value pair object
 */
export function parseKeyedSource(
  param: KeyedSource<DataType.ANY>[],
): Record<string, string | boolean | undefined> {
  if (!param || !param?.length) {
    return {};
  }
  return Object.fromEntries(
    param.map((param: KeyedSource<DataType.ANY>) => [
      param.key,
      param.source.type === 'VALUE' ? param.source.value : undefined,
    ]),
  );
}

/**
 * strips null and undefined keys from object
 * @param obj
 * @returns
 */
export function stripUndefinedAndNull<T extends object>(obj: T): NonNullUndefinedField<T> {
  const newObj = {};
  Object.keys(obj).forEach((key: string) => {
    if (isObject(obj[key])) {
      newObj[key] = stripUndefinedAndNull(obj[key]);
    } else if (obj[key] !== undefined && obj[key] !== null) {
      newObj[key] = obj[key];
    }
  });
  return newObj as NonNullUndefinedField<T>;
}
